export const GBASE_REFRESH_EXPIRED_DETAIL = 'GBase authorization has expired. Please re-authorize with GBase.';

interface GbaseErrorResponse {
  status: number;
  url: string;
  detail: unknown;
}

const isGbasePathname = (url: string) => {
  try {
    const pathname = new URL(url, 'https://local.invalid').pathname;
    return pathname === '/api/auth/gbase' || pathname.startsWith('/api/auth/gbase/');
  } catch {
    return false;
  }
};

export const isGbaseRefreshExpiredResponse = ({ status, url, detail }: GbaseErrorResponse) => {
  if (
    status === 500 &&
    typeof detail === 'object' &&
    detail !== null &&
    'error_type' in detail &&
    detail.error_type === 'gbase_refresh_expired'
  ) {
    return true;
  }

  return status === 401 && isGbasePathname(url) && detail === GBASE_REFRESH_EXPIRED_DETAIL;
};
